import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import treeSearch from '../images/icon_home_search.png';
import treeViewCollapse from '../../assets/svg/Tree_view_collapse.svg';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';
import treeViewExpand from '../../assets/svg/Tree_view_expand.svg';
import { BsChevronDown } from "react-icons/bs";
import { BsChevronRight as BsChevronUp } from "react-icons/bs";
import { AiOutlinePlusCircle } from 'react-icons/ai'
import { IoMdArrowDropdown } from 'react-icons/io';

import { useDispatch } from 'react-redux';
import { createPkgsAct, createTagsAct, createTTAct, switchCategoryTags, switchInsTypeTags, switchPkgTags, switchTagPkgAct, switchTagTTAct, switchTTTagAct, updTagAct } from '../redux/project/projActions';
import getDt, { getEnvironment, useProjBuCode } from '../../utils';
import { getDtfrmt } from '../../utils';
import { getTTLabel } from '../../utils';
import './tagTree.scss';
import { showLoader } from '../redux/ctrl/ctrlActions';
// import {TiTick,TiCancel} from 'react-icons/ti';
import toastr from 'toastr';
import "toastr/build/toastr.min.css";
import { TreeView } from '@mui/x-tree-view'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import { Autocomplete, Grid, TextField, Button, IconButton } from '@mui/material';
import StyledTooltip from '../shared/toolTip/StyledTooltip';
import { createPrjAsn, fetchPrjAsn, updatePrjAsn } from '../redux/prjasn/prjAsnActions';
import { VscCollapseAll, VscExpandAll } from "react-icons/vsc";
import { MdAdd, MdClear, MdKeyboardArrowDown, MdKeyboardArrowRight, MdAddCircleOutline, MdEdit, MdClose } from "react-icons/md";
import CustomTreeItem from './TreeItem';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import Loader from '../loader';
import { FaAnglesLeft } from "react-icons/fa6";
import { ItemForm } from '@as-pmo-lrp-sso/item-search';
import { IoPricetagOutline } from 'react-icons/io5';
import SearchItemBtnGrp from './SearchItemBtnGrp';
import { alpha } from "@mui/material/styles";
import COLORS from '../styles/COLORS';

const primaryColor = COLORS.blue ;
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
    //  cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}


const TagTree = (props) => {
  const { slctRev, gridApi } = props
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const ctrlState = useSelector((state) => state.ctrl);
  const { t, i18n } = useTranslation();
  // const proj = useSelector((state) => state.ctrl.data)
  // let techTyps = useSelector((state) => state.ctrl.techTypes);
  const pkg = useSelector((state) => state.ctrl.pkg);
  const prjBUCode = useProjBuCode()
  const uptag = useSelector(state => state.prjasn.projectsAsn);
  const techTypsLkp = useSelector((state) => state.ctrl.techTypes).filter(o => o.businessUnits.split(";").includes(prjBUCode));
  const addTagTechTypsLkp = useSelector((state) => state.ctrl.techTypes).filter(o => o.businessUnits.split(";").includes(prjBUCode));;
  const techTyps = useSelector((state) => state.project.techTyps)
  const tags = useSelector((state) => state.project.tags);
  const loading = useSelector((state) => state.ctrl.loading);
  const active_revision = useSelector((state) => state.ctrl.pkg.active_revision)
  const { showProgressBar } = useSelector((state) => state.project);
  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === 'Instrumentation' ? true : false;
  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);
  const nonConfigProducts = useSelector((state) => state.ctrl.nonConfigProducts);


  const crTagCap = profile.capb.findIndex(o => o.PWSCRTAG === 'Y') >= 0 ? false : true;
  const updTagCap = profile.capb.findIndex(o => o.PWSUPTAG === 'Y') >= 0 ? false : true;
  //----search------

  const handleSearchInput = (e) => {
    e.preventDefault();
    setSearchTag(e.target.value);
    props.setFindTag(e.target.value)
  }
  // const [hidePkgs, setHidePkgs] = useState([]);
  // const [hideCtgrs, setHideCtgrs] = useState([])
  // const [hiddenTagPkgs, setHiddenTagPkgs] = useState([]);
  let fPkg = useSelector((state) => state.ctrl.pkg);
  let pkgs1 = useSelector((state) => state.project.packages.filter((o) => o.project_id === fPkg.project_id && o.package_id === fPkg.package_id));
  const gtechTyps = useSelector((state) => state.project.techTyps);

  // const profile = useSelector((state) => state.profile);
  const [state, setState] = useState({
    ttList: [],
    showTT: true,
    selectedTT: [],
  });
  let pkgs = [...pkgs1];


  let tempCardNodes = []
  techTypsLkp.forEach(i => { tempCardNodes.push(i.category); tempCardNodes.push(i.instrumentType) })
  const [cardNodes, setCardNodes] = useState(tempCardNodes)
  const [treeNodes, setTreeNodes] = useState([])
  const [tagState, setTagState] = useState({ showPkg: false, message: '', refresh: false });
  const [sidebarState, setSidebarState] = useState(true);
  const [searchtag, setSearchTag] = useState("");
  const [throatCheck, setThroatCheck] = useState(false);
  const [treeCheckbox, setTreeCheckbox] = useState('treeCheckbox');
  const [writeAcc, setWriteAcc] = useState();
  const [isSearchItemOpen, setIsSearchItemOpen] = useState(false);
  const [searchItemType, setSearchItemType] = useState('');
  const [searchQuantity, setSearchQuantity] = useState('MULTIPLE');
  const addTagInputRef = useRef(null);
  const [isAddTagOpen, setIsAddTagOpen] = useState(false);
  const [isEditTagOpen, setIsEditTagOpen] = useState(false);
  const [selectedEditTag, setSelectedEditTag] = useState(null);
  const [addTagForm, setAddTagForm] = useState({
    tagNumber: '',
    productDescription: '',
    instrumentType: '',
    technologyType: '',
  });

  const isCreateTagDisabled = useMemo(() => {
    return slctRev?.value != active_revision ? true : false || !writeAcc || crTagCap
  }, [slctRev?.value, active_revision, writeAcc, crTagCap])


  const handleCloseSideBar = () => {
    props.setSearchValue(searchtag);
    props.setSidebarState(false);
  }
  useEffect(() => {
    if (props.getsearchValue.length > 0) {
      setSearchTag(props.getsearchValue);
    }
  }, [props.getsearchValue])

  // const sideBarRef = React.useRef(null);
  let chkCatNode = []

  let pl = null;
  useEffect(() => {
    setState({
      ttList: [],  // const dispatch = useDispatch();

      showTT: true,
      selectedTT: [],
    })
  }, [slctRev])




  useEffect(() => {
    let write_accs = uptag.filter((item) => item.project_id === ctrlState.data?.project_id && profile.email.toLowerCase() === item.email_id.toLowerCase())[0]?.write_access
    write_accs = ctrlState.data.created_by?.toLowerCase() === profile.email?.toLowerCase() || write_accs == 'Y' ? true : false
    if (!write_accs) {
      write_accs = (profile.capb.findIndex((o) => o.PWSADACC === 'Y') >= 0 ? true : false);
    }
    setWriteAcc(write_accs)
  }, [uptag, ctrlState.data]);


  // let tempttListCat = state.ttList.length > 0 ? state.ttList.map(i => i.category) : []
  // let ttListCat = [...new Set(tempttListCat)]

  const getUnique = (array) => {
    return [...new Set(array)]
  }

  const sortAlphaNum = (a, b) => b.localeCompare(a, 'en', { numeric: true })
  const sortAlphaNumTag = (a, b) => a.tag_number?.localeCompare(b?.tag_number, 'en', { numeric: true })

  // const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  //   '& .MuiSvgIcon-root': { fontSize: 16, },
  //   '&.MuiCheckbox-root': {
  //     color: "#00aa7e",
  //     padding: 0,
  //     borderRadius: 0,
  //     marginRight: '4px',
  //     pointerEvents: 'auto'
  //   },
  // }));

  // const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  //   [`& .${treeItemClasses.group}`]: { borderLeft: `1px dashed`, borderColor: '#808080', marginLeft: '15px' },
  //   [`& .${treeItemClasses.label}`]: { overflow: 'hidden' },
  //   [`& .${treeItemClasses.content}`]: { padding: '0px 0px 0px 8px' },
  //   [`& .${treeItemClasses.iconContainer}`]: { pointerEvents: 'auto' },
  // }))
  const expandAllTree = () => {
    let tempTreeNodes = []
    let count = 0
    chkCatNode = []
    if (techTyps.length == 0) {
      setTreeNodes([pkg.package_id] + "")
    }
    techTyps.forEach((i, index, array) => {
      tempTreeNodes.push(i.technology_name, i.instrument_type, (i.technology_id).toString())
      // tempTreeNodes.push(i.technology_name, i.instrument_type)
      chkCatNode.push(i.technology_name)
      count++;
      if (count === array.length) {
        let tempArr = getUnique(tempTreeNodes)
        setTreeNodes([pkg.package_id + "", ...tempArr])
      }
    })
    // else {
    //   setTempTT([...techTyps])
    //   techTyps.forEach((i, index, array) => {
    //     tempTreeNodes.push(i.technology_name, i.instrument_type, i.technology_id + '')
    //     chkCatNode.push(i.technology_name)
    //     count++;
    //     if (count === array.length) {
    //       let tempArr = getUnique(tempTreeNodes)
    //       setTreeNodes([pkg.package_name, ...tempArr])
    //     }
    //   }
    //   )
    //   setTempVar(false)
    // }
  }

  useEffect(() => {
    expandAllTree()
  }, [techTyps.length])

  useEffect(() => {
    if (throatCheck) {
      setTimeout(() => {
        setThroatCheck(false);
        setTreeCheckbox('treeCheckbox');
      }, 600);
    }
  }, [throatCheck])

  const toggleSelection = (e) => {
    setThroatCheck(true);
    setTreeCheckbox('treeCheckbox checkWait');
    e.stopPropagation()
    const nodeType = e.target.getAttribute("data-type")
    if (nodeType === 'PKG') {
      pl = {
        package_id: e.target.getAttribute("data-identifier"),
        selected: e.target.checked
      }
      dispatch(switchPkgTags(pl))
    }
    else if (nodeType === 'TN') {
      pl = {
        package_id: pkg.package_id,
        category: e.target.getAttribute("data-identifier"),
        // technology_ids: techTyps.filter(i => i.technology_name == e.target.getAttribute("data-identifier")).map(o => o.technology_id),
        selected: e.target.checked
      }
      dispatch(switchCategoryTags(pl))
    }
    else if (nodeType === 'IT') {
      pl = {
        package_id: pkg.package_id,
        instrumentType: e.target.getAttribute("data-identifier"),
        // technology_ids: techTyps.filter(i => i.instrument_type == e.target.getAttribute("data-identifier")).map(o => o.technology_id),
        selected: e.target.checked
      }
      dispatch(switchInsTypeTags(pl))
    }
    else if (nodeType === 'PD') {
      pl = {
        package_id: pkg.package_id,
        technology_id: e.target.getAttribute("data-identifier"),
        selected: e.target.checked
      }
      dispatch(switchTTTagAct(pl))
    }
    else if (nodeType === 'TAG') {
      pl = {
        package_id: pkg.package_id,
        technology_id: e.target.getAttribute("data-identifier").split('~')[0],
        tag_id: e.target.getAttribute("data-identifier").split('~')[1],
        selected: e.target.checked
      }
      dispatch(switchTagTTAct(pl))
    }
  }

  const onSelectedTT = (e) => {
    let isValueChecked = e.target.checked;
    let temp = []
    temp = state.selectedTT
    if (isValueChecked) {
      temp.push({ ttId: e.target.value })
      setState(prevState => { return { ...prevState, selectedTT: temp } })
    } else {
      var index = state.selectedTT.findIndex(o => o.ttId === e.target.value)
      if (index > -1) {
        temp.splice(index, 1)
        setState(prevState => { return { ...prevState, selectedTT: temp } })
      }
    }
  }

  const onSelectedInsTyp = (e) => {
    console.log("onSelectedCat", e.target.checked)
    e.stopPropagation();
    let isValueChecked = e.target.checked;
    state.ttList.filter(i => i.instrumentType == e.target.value).forEach(i => {
      onSelectedTT({ target: { checked: isValueChecked, value: i.lookup_code } })
    })
  }
  const onSelectedCat = (e) => {
    console.log("onSelectedCat")
    e.stopPropagation();
    let isValueChecked = e.target.checked;
    state.ttList.filter(i => i.category == e.target.value).forEach(i => {
      onSelectedTT({ target: { checked: isValueChecked, value: i.lookup_code } })
    })
  }

  const categoriesTree = () => {
    return getUnique(techTyps.map(i => i.technology_name))
      .filter(i => (isInstrumentationTab && !commercialTypes.includes(i)))
      .map((cat, index) => {
        // let tt = cTechTyps(project_id, package_id, cat)
        let insTyps = cInsTyps(cat)
        let chk = techTyps.some(tt => tt.technology_name == cat && tt.selected == 'Y')
        cat = cat === "Vanessa" ? cat + ' ' : cat;
        return (
          <CustomTreeItem key={cat} nodeId={cat}
            label={
              <label className='treeLabel' >
                <input className={treeCheckbox} disabled={throatCheck} type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={chk} data-type={"TN"} data-identifier={cat} />
                <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()} >{cat}</span>
              </label>
            }
          >
            {insTyps}
          </CustomTreeItem>
        )

      })
  }

  const cInsTyps = (cat) => {
    let gInsTyps = getUnique(techTyps.filter(i => i.technology_name == cat).map(i => i.instrument_type))
    let insTypItem = gInsTyps.map((itype) => {
      let tt = cTechTyps(itype, cat)
      let chk1 = techTyps.some(tt => tt.instrument_type == itype && tt.selected == 'Y')

      return (
        <CustomTreeItem key={itype} nodeId={itype}
          label={
            // <StyledTooltip title={itype} placement="bottom" disableInteractive>

            // <FormControlLabel control={<CustomCheckbox checked={chk1} inputProps={{
            //   'data-type': 'IT',
            //   'data-identifier': itype
            // }}
            //   onClick={e => toggleSelection(e)} />} label={itype} />

            <label className='treeLabel'>
              <input className={treeCheckbox} disabled={throatCheck} type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={chk1} data-type='IT' data-identifier={itype} />
              <span onClick={(e) => e.stopPropagation()} className='MuiFormControlLabel-label' >{itype}</span>
            </label>

            // </StyledTooltip> 
          }
        >
          {tt}
        </CustomTreeItem>
      )

    })
    return insTypItem
  }

  const cTechTyps = (itype, cat) => {
    // let itemTTyps = null;
    let ftechTyps = techTyps.filter(i => i.instrument_type == itype)
    let consTechTypes = ftechTyps.map((ttype, index) => {
      let ttItem = null;
      // !showProgressBar && 
      let tag = !showProgressBar && state.showTT && ctags(itype, ttype, cat)
      ttItem = (
        <CustomTreeItem key={ttype.technology_id} nodeId={(ttype.technology_id).toString()}
          label={

            //  <StyledTooltip title={ttype?.product_description} placement="bottom" disableInteractive>

            // <FormControlLabel control={<CustomCheckbox checked={ttype.selected == 'Y' ? true : false} inputProps={{
            //   'data-type': 'PD',
            //   'data-identifier': ttype.technology_id
            // }}
            //   onClick={e => toggleSelection(e)} />} label={ttype?.product_description} />

            <label className='treeLabel'>
              <input className={treeCheckbox} disabled={throatCheck} type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={ttype.selected == 'Y' ? true : false} data-type='PD' data-identifier={ttype.technology_id} />
              <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()} >{ttype?.product_description}</span>
            </label>

            // </StyledTooltip>
          }
        >
          {tag}
        </CustomTreeItem>
      )
      return ttItem;
    }
    )
    return consTechTypes
  }

  const getTags = useSelector((state) => state.project.tags)

  const ctags = (itype, ttype, cat) => {
    let itemTags = null;
    let fetchTags = treeNodes.includes((ttype.technology_id).toString()) && getTags?.filter(i => i.gen_instrument_type == itype && i.gen_prod_desc == ttype.product_description)
    let consTags = null
    consTags = treeNodes.includes((ttype.technology_id).toString()) && fetchTags.sort(sortAlphaNumTag).map((o, index) => {
      // if(index>100){return}
      // console.log('---tags')
      let tagItem = null;
      tagItem = (
        <React.Fragment key={o.tag_number}>
          <div style={{ marginLeft: '32px' }} hidden={!state.showTT} >

            {/* <StyledTooltip title={o.tag_number} placement="bottom" disableInteractive> */}

            {/* <FormControlLabel control={<CustomCheckbox checked={o.selected == 'Y' ? true : false} inputProps={{
                'data-type': 'TAG',
                'data-identifier': ttype.technology_id + '~' + o.tag_id
              }} onClick={e => toggleSelection(e)} />}
                label={o.tag_number} /> */}

            <label className='treeLabel'>
              <input className={treeCheckbox} disabled={throatCheck} type='checkbox' onChange={e => toggleSelection(e)} checked={o.selected == 'Y' ? true : false} data-type='TAG' data-identifier={ttype.technology_id + '~' + o.tag_id} />
              <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()} >{o.tag_number}</span>
            </label>

            {/* </StyledTooltip> */}
          </div>
        </React.Fragment>
      )
      return tagItem
    }
    )
    itemTags = (
      <React.Fragment>
        <div style={{ marginTop: '4px', marginLeft: '22px', display: 'flex', alignItems: 'center' }} hidden={!state.showTT || isInstrumentationTab} >
          <IoPricetagOutline className="d-inline align-top abtn" height="35" />
          <input maxLength={230} name='tag' style={{ height: '20px', width: '102px', fontSize: '11px', borderRadius: '3px' }}
            data-package={cat + '~' + itype + '~' + ttype.product_description + '~' + ttype.technology_id + '~' + ttype.revision} type='text'
            disabled={isCreateTagDisabled}
            placeholder={isInstrumentationTab ? t('Add Tag') : t('Add Item')}
            onKeyDown={(e) => onKeyDown(e)}
          />
        </div>
        {consTags}
      </React.Fragment>
    )
    return itemTags;
  }

  // const hidePkg = (pkgId) => {
  //   let thidePkg = [...hidePkgs];
  //   if (!thidePkg.includes(pkgId)) {
  //     thidePkg.push(pkgId);
  //   } else {
  //     thidePkg = thidePkg.filter(package_id => package_id !== pkgId)
  //   }
  //   setHidePkgs(thidePkg);
  // }

  // const isPkgHidden = (pkgId) => {
  //   const thidePkg = [...hidePkgs];
  //   return thidePkg.includes(pkgId);
  // }

  // const hideCategory = (category) => {
  //   let thideCtgr = [...hideCtgrs];
  //   if (!thideCtgr.includes(category)) {
  //     thideCtgr.push(category);
  //   } else {
  //     thideCtgr = thideCtgr.filter(cat => cat !== category)
  //   }
  //   setHideCtgrs(thideCtgr);
  // }

  // const isCategoryHidden = (category) => {
  //   const thideCtgr = [...hideCtgrs];
  //   return thideCtgr.includes(category);
  // }


  // const hideChildTags = (pkgId) => {
  //   let tempHiddenTagPkgs = [...hiddenTagPkgs];
  //   if (!tempHiddenTagPkgs.includes(pkgId)) {
  //     tempHiddenTagPkgs.push(pkgId);
  //   } else {
  //     tempHiddenTagPkgs = tempHiddenTagPkgs.filter(package_id => package_id !== pkgId)
  //   }
  //   setHiddenTagPkgs(tempHiddenTagPkgs);
  // }


  // const isTagHidden = (pkgId) => {
  //   const tempHiddenTagPkgs = [...hiddenTagPkgs];
  //   return tempHiddenTagPkgs.includes(pkgId);
  // }

  const AddTTCard = () => {
    return (
      <Card hidden={state.showTT} style={{
        borderRadius: 16,
        boxShadow: '-3px 4px 20px 3px #BDC9D7',
        position: 'absolute',
        zIndex: 2,
        left: '10px',
        width: '92%',
        top: '115px',
      }}>
        <CardContent style={{ padding: '16px 5px' }}>
          <TreeView
            expanded={cardNodes}
            onNodeToggle={(e, id) => setCardNodes(id)}
            defaultCollapseIcon={<MdKeyboardArrowDown style={{ color: COLORS.green }} />}
            defaultExpandIcon={<MdKeyboardArrowRight style={{ color: COLORS.green }} />}>
            {
              getUnique(state.ttList.length > 0 ? state.ttList.filter(i => i.type != 'COMMERCIAL').map(i => i.category) : []).map((cat, index) => {
                let tempArrIns = []
                let tempArrCat = []
                state.selectedTT.forEach(i => {
                  techTypsLkp.forEach(o => {
                    if (i.ttId == o.lookup_code) {
                      tempArrIns.push(o.instrumentType)
                      tempArrCat.push(o.category)
                    }
                  })
                })
                return (
                  <CustomTreeItem key={cat} nodeId={cat} label={
                    // <FormControlLabel control={<CustomCheckbox value={cat} checked={tempArrCat.includes(cat)} onClick={e => onSelectedCat(e)} />} label={cat} />
                    <label className='treeLabel' >
                      <input className={treeCheckbox} disabled={throatCheck} type='checkbox' value={cat} onClick={(e) => e.stopPropagation()} onChange={e => onSelectedCat(e)} checked={tempArrCat.includes(cat)} />
                      <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()}>{cat}</span>
                    </label>
                  }>
                    {
                      getUnique(state.ttList.filter(i => i.category == cat).map(o => o.instrumentType)).map((itype, index) => {
                        return (
                          <CustomTreeItem key={itype} nodeId={itype} label={
                            // <StyledTooltip title={itype} placement="bottom" disableInteractive >
                            // <FormControlLabel control={<CustomCheckbox value={itype} checked={tempArrIns.includes(itype)} onClick={e => onSelectedInsTyp(e)} />} label={itype} />
                            <label className='treeLabel' >
                              <input className={treeCheckbox} disabled={throatCheck} type='checkbox' value={itype} onClick={(e) => e.stopPropagation()} onChange={e => onSelectedInsTyp(e)} checked={tempArrIns.includes(itype)} />
                              <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()}>{itype}</span>
                            </label>
                            //</StyledTooltip>
                          }>
                            {
                              state.ttList.filter(i => i.instrumentType == itype).map((ttype, index) => {
                                return (
                                  <CustomTreeItem key={ttype.lookup_code} nodeId={ttype.lookup_code}
                                    label={

                                      <StyledTooltip title={ttype.description} placement="bottom" disableInteractive>

                                        {/* <FormControlLabel control={<CustomCheckbox value={ttype.lookup_code}
                                          checked={state.selectedTT.map(i => i.ttId).includes(ttype.lookup_code)}
                                          onClick={(e) => onSelectedTT(e)} />} label={ttype.description} /> */}

                                        <label className='treeLabel' >
                                          <input className={treeCheckbox} disabled={throatCheck} type='checkbox' value={ttype.lookup_code}
                                            onChange={e => onSelectedTT(e)} onClick={(e) => e.stopPropagation()}
                                            checked={state.selectedTT.map(i => i.ttId).includes(ttype.lookup_code)}
                                          />
                                          <span className='MuiFormControlLabel-label' >{ttype.description}</span>
                                        </label>

                                      </StyledTooltip>
                                    }
                                  />
                                )
                              })
                            }
                          </CustomTreeItem>
                        )
                      })}
                  </CustomTreeItem>
                )
              })
            }
          </TreeView>
          <CardActions style={{ padding: '10px 0px 0px 0px', justifyContent: 'center' }} >
            <MdClear style={{ color: 'red', cursor: 'pointer' }} onClick={() => setState({
              ttList: [],
              showTT: true,
              selectedTT: [],
            })} />
            <MdAdd style={{ marginLeft: '20px', color: COLORS.green, cursor: 'pointer' }} onClick={() => onApply()} />
          </CardActions>
        </CardContent>
      </Card>
    )
  }

  const commPrdTree = () => {
    const commTypes = techTyps
      .filter((i) => i.technology_name === wsTabValue)
      .map((type) => {
        const tt = cTechTyps(type.instrument_type, type.technology_name);
        return tt;
      });
    return commTypes;
  };

  let packages;

  packages = pkgs.map((currpkg, index) => {
    let item = null;
    let ctgrs = null
    ctgrs = categoriesTree()
    const commTree = commPrdTree()
    item = (
      <React.Fragment key={"P" + index}>

        {isInstrumentationTab && !state.showTT && <AddTTCard />}
        <TreeView
          expanded={[...treeNodes]}
          onNodeToggle={(e, id) => setTreeNodes(id)}
          defaultCollapseIcon={<MdKeyboardArrowDown style={{ color: COLORS.green }} />}
          defaultExpandIcon={<MdKeyboardArrowRight style={{ color: COLORS.green }} />}
        >
          {/* <div hidden={!isInstrumentationTab || !treeNodes.includes(pkg.package_id + "")} style={{ position: 'absolute', zIndex: 1, top: '113px', left: '20px' }}>
            <MdAddCircleOutline className="d-inline align-top abtn2" width="auto" height="35" />
            <input name='TT' maxLength="50" onClick={e => handleChange(e)} onChange={(e) => handleChange(e)} style={{ height: '20px', width: '170px', fontSize: '11px', borderRadius: '3px' }} type='text' placeholder={t('Add Technology Type')} disabled={isCreateTagDisabled} />
          </div> */}
          <CustomTreeItem nodeId={pkg.package_id + ""}
            label={
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <label className='treeLabel' >
                  <input className={treeCheckbox} disabled={throatCheck} type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={pkg.selected == 'Y' ? true : false} data-type='PKG' data-identifier={pkg.package_id} />
                  <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()}>{pkg.package_name}</span>
                </label>
                {
                  !treeNodes.includes('DP Flow') && !treeNodes.includes('Vanessa') && !treeNodes.includes('DP Level') && !treeNodes.includes('Flow') && treeNodes.includes(pkg.package_id + "") ?
                    <VscExpandAll style={{ color: COLORS.green, marginRight: '5px', fontSize: '18px' }} onClick={(e) => { e.stopPropagation(); expandAllTree() }} />
                    : treeNodes.includes(pkg.package_id + "") ?
                      <VscCollapseAll style={{ color: COLORS.green, marginRight: '5px', fontSize: '18px' }} onClick={(e) => { e.stopPropagation(); setTreeNodes([pkg.package_id + ""]) }} />
                      : null
                }
              </div>
            }
          >
            {isInstrumentationTab ?
              <>
                {/* <br /> */}
                {ctgrs}
              </>
              : commTree}
          </CustomTreeItem>
        </TreeView>
      </React.Fragment>
    )
    return item;
  }
  )

  const onBlurPkg = (e) => {
    let invalid = e.currentTarget.getAttribute("data-invalid");
    if (invalid !== undefined && invalid === "true") {
      e.currentTarget.focus();
      setTagState({ showPkg: true, message: 'Package ' + e.target.value + ' should be unique' })
    }
  }

  const onBlurTag = (e) => {
    let invalid = e.currentTarget.getAttribute("data-invalid");
    if (invalid !== undefined && invalid === "true") {
      // e.currentTarget.focus();
      setTagState({ showPkg: true, message: 'Tag ' + e.target.value + ' should be unique' })
      e.currentTarget.value = ''
    }
  }

  const onApply = () => {
    let pl = [];
    state.selectedTT.map(
      (o) => {

        pl.push(
          {
            // "technology_id": "",
            project_id: pkg.project_id,
            package_id: pkg.package_id,
            package_name: pkg.package_name,
            technology_name: techTypsLkp.filter(i => i.lookup_code == o.ttId).map(q => q.category)[0], //category
            instrument_type: techTypsLkp.filter(i => i.lookup_code == o.ttId).map(q => q.instrumentType)[0], //instrument type
            product_description: techTypsLkp.filter(i => i.lookup_code == o.ttId).map(q => q.description)[0], //technology type
            created_by: profile.email,
            creation_date: getDt(new Date()),
            last_updatedby: profile.email,
            last_updatedate: getDt(new Date()),
            // "enabled_flag": "",
            selected: "Y",
            revision: slctRev.value

          }
        )
      }

    )

    if (pl.length > 0) {
      dispatch(showLoader(true));
      dispatch(createTTAct(pl))
      setState({
        ttList: [],
        showTT: true,
        selectedTT: [],
      })
    }
    if (pl.length === 0) {
      toastr.error(t('Please select atleast one technology type'))
      // setState({
      //   ttList: [],
      //   showTT: true,
      //   selectedTT: [],
      // })
    }

  }
  const handleChange = (e) => {
    // e.preventDefault();
    // e.stopPropagation()
    if (e.target.name === 'TT') {
      // setState({
      //   ttList: [],
      //   showTT: true,
      //   selectedTT: [],
      // })
      let getTT = techTypsLkp;

      if (e.target.value !== "" || e.target.value === "") {
        let srchTT = e.target.value.toUpperCase();
        let srchTTyps = [];
        if (srchTT) {
          srchTTyps = getTT.filter(o => (o.description?.toUpperCase().includes(srchTT)));
        }
        else {
          srchTTyps = getTT;
        }
        let aTT = [];
        let fTT;
        if (srchTTyps.length > 0) {
          srchTTyps.map((values, index) => {
            fTT = techTyps.findIndex((o) => o.technology_name == values.category && o.instrument_type == values.instrumentType && o.product_description == values.description);
            if (fTT < 0) {
              aTT.push(values)
            }
          }
          )
        }
        setState({ ...state, ttList: aTT, showTT: aTT.length > 0 ? false : true })
        if (aTT.length === 0) {
          toastr.error(t('No technology type exists'))
        }
      }
      else {
        setState({ ...state, ttList: [] })
      }

    } else if (e.target.name === 'tag') {
      e.target.setAttribute("data-invalid", false);
    }
  }

  const togglePkgModal = () => {
    setTagState({ showPkg: false, message: null })
  }

  // const toggleSidebar = (val) => {
  //   // ---for dragger-----
  //   if (!val) props.setPositionFirst({ positionFirstX: 0 })
  //   // ---------------
  //   setSidebarState(val)
  // }

  const onSrchItemClicked = (productType) => {
    const selectedRows = gridApi?.getSelectedRows() || [];
    const isEditItem = selectedRows.length === 1 && !productType ? true : false;
    console.log("isEditItem", isEditItem);

    if (selectedRows.length != 1 && !productType) {
      toastr.error(t('Please select only one row.'));
      return;
    }
    setSearchItemType(isEditItem ? selectedRows[0].gen_prod_desc : productType);
    setSearchQuantity(isEditItem ? 'SINGLE' : 'MULTIPLE');
    setIsSearchItemOpen(true);
  }

  const openAddTagDialog = () => {
    setAddTagForm({
      tagNumber: '',
      productDescription: '',
      instrumentType: '',
      technologyType: '',
    });
    setIsAddTagOpen(true);
  };

  const openEditTagDialog = () => {
    const selectedRows = gridApi?.getSelectedRows() || [];

    if (selectedRows.length !== 1) {
      toastr.error(t('Select only one Tag.'));
      return;
    }

    const selectedRow = selectedRows[0];

    setSelectedEditTag(selectedRow);
    setAddTagForm({
      tagNumber: selectedRow.tag_number || '',
      productDescription: selectedRow.gen_prod_desc || '',
      instrumentType: selectedRow.gen_instrument_type || '',
      technologyType: selectedRow.gen_technology_type || selectedRow.technology_name || '',
    });
    setIsEditTagOpen(true);
  };

  const handleAddTagFieldChange = (field) => (e) => {
    const value = e.target.value;

    if (field === 'productDescription') {
      const selectedLookup = addTagTechTypsLkp.find(
        (item) =>
          item.description === value &&
          (!isEditTagOpen || item.category === addTagForm.technologyType)
      );

      setAddTagForm((prevState) => ({
        ...prevState,
        productDescription: value,
        instrumentType: selectedLookup?.instrumentType || '',
        technologyType: isEditTagOpen
          ? prevState.technologyType
          : selectedLookup?.category || '',
      }));
      return;
    }

    setAddTagForm((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleAddTagCancel = () => {
    setIsAddTagOpen(false);
  };

  const handleEditTagCancel = () => {
    setIsEditTagOpen(false);
    setSelectedEditTag(null);
  };

  const findSelectedLookup = (productDescription) => {
    return addTagTechTypsLkp.find(
      (item) => item.description === productDescription
    );
  };

  const buildTagPayload = ({ tagNumber, technologyType }) => {
    const divisionCode = techTypsLkp.find(
      (item) =>
        item.category === technologyType.technology_name &&
        item.instrumentType === technologyType.instrument_type &&
        item.description === technologyType.product_description
    )?.division;

    return createTagPayload({
      tagNumber,
      techName: technologyType.technology_name,
      insType: technologyType.instrument_type,
      prodDesc: technologyType.product_description,
      techId: technologyType.technology_id?.toString(),
      rev: technologyType.revision || slctRev.value,
      divisionCode,
    });
  };

  const handleAddTagSave = () => {
    const productDescription = addTagForm.productDescription.trim();

    if (!productDescription) {
      toastr.error(t('Product Description is mandatory.'));
      return;
    }

    const selectedLookup = findSelectedLookup(productDescription);

    if (!selectedLookup) {
      toastr.error(t('No technology type exists'));
      return;
    }

    let tagNumber = addTagForm.tagNumber?.trim();

    if (!tagNumber) {
      tagNumber = generateTagNumber(getTagPrefix(productDescription), tags);
    } else {
      tagNumber = tagNumber.toUpperCase();
    }

    if (isDuplicateTag(tagNumber, tags)) {
      toastr.error(t(`"${tagNumber}" already exists. Please enter a unique value.`));
      return;
    }

    const technologyTypeExists = techTyps.find(
      (techType) =>
        techType.technology_name === selectedLookup.category &&
        techType.instrument_type === selectedLookup.instrumentType &&
        techType.product_description === selectedLookup.description
    );

    const autoCreateTechType = technologyTypeExists ? undefined : {
      project_id: pkg.project_id,
      package_id: pkg.package_id,
      package_name: pkg.package_name,
      technology_name: selectedLookup.category,
      instrument_type: selectedLookup.instrumentType,
      product_description: selectedLookup.description,
      created_by: profile.email,
      creation_date: getDt(new Date()),
      last_updatedby: profile.email,
      last_updatedate: getDt(new Date()),
      selected: 'Y',
      revision: slctRev.value,
    };
    const technologyTypeForTag = technologyTypeExists || autoCreateTechType;

    dispatch(showLoader(true));
    dispatch(createTagsAct(
      getTagsGroupedByTechnology([buildTagPayload({
        tagNumber,
        technologyType: technologyTypeForTag,
      })]),
      autoCreateTechType
    ));
    setIsAddTagOpen(false);
  };

  const handleEditTagSave = () => {
    if (!selectedEditTag) {
      toastr.error(t('Tag is not selected.'));
      return;
    }

    if (!addTagForm.productDescription.trim()) {
      toastr.error(t('Product Description is mandatory.'));
      return;
    }

    const selectedLookup = addTagTechTypsLkp.find(
      (item) =>
        item.description === addTagForm.productDescription &&
        item.category === addTagForm.technologyType
    );

    if (!selectedLookup) {
      toastr.error(t('No technology type exists'));
      return;
    }

    const technologyTypeExists = techTyps.find(
      (techType) =>
        techType.technology_name === selectedLookup.category &&
        techType.instrument_type === selectedLookup.instrumentType &&
        techType.product_description === selectedLookup.description
    );

    const autoCreateTechType = technologyTypeExists ? undefined : {
      project_id: pkg.project_id,
      package_id: pkg.package_id,
      package_name: pkg.package_name,
      technology_name: selectedLookup.category,
      instrument_type: selectedLookup.instrumentType,
      product_description: selectedLookup.description,
      created_by: profile.email,
      creation_date: getDt(new Date()),
      last_updatedby: profile.email,
      last_updatedate: getDt(new Date()),
      selected: 'Y',
      revision: slctRev.value,
    };

    const technologyTypeForTag = technologyTypeExists || autoCreateTechType;

    const updatedRow = {
      ...selectedEditTag,
      tag_number: addTagForm.tagNumber,
      gen_prod_desc: technologyTypeForTag.product_description,
      gen_instrument_type: technologyTypeForTag.instrument_type,
      gen_technology_type: technologyTypeForTag.technology_name,
      technology_name: technologyTypeForTag.technology_name,
      instrument_type: technologyTypeForTag.instrument_type,
      product_description: technologyTypeForTag.product_description,
      technology_id: technologyTypeForTag.technology_id?.toString() || selectedEditTag.technology_id,
      revision: technologyTypeForTag.revision || selectedEditTag.revision,
    };

    dispatch(updTagAct(updatedRow, autoCreateTechType));
    setIsEditTagOpen(false);
    setSelectedEditTag(null);
  };

  const focusEditTagInput = () => {
    const tagInput = document.querySelector('input[name="tag"]');

    if (!tagInput) {
      toastr.error(t('No tag input available.'));
      return;
    }

    tagInput.focus();
  };

  const generateTagNumber = (prefix, existingTags, offset = 0) => {
    const filteredTags = existingTags
      ?.filter((i) =>
        i?.tag_number?.toUpperCase().match(new RegExp(`^${prefix}[0-9]+$`))
      )
      .map((i) => i?.tag_number?.toUpperCase())
      .sort(sortAlphaNum);

    const lastTagNumber = filteredTags?.[0]?.substring(prefix.length) || 0;
    return `${prefix}${Number(lastTagNumber) + 1 + offset}`;
  };

  const getTagPrefix = (productType) => {
    const prefixMapping = {
      "Document": "DS",
      "Drawing": "DS",
      "Certificates": "DS",
      "Order Services": "DS",
      "Buy Resale": "BR",
      "Accessories": "SP",
      "Parts": "SP",
      "Spares": "SP"
    };

    return prefixMapping[productType] || "TAG";
  };

  const getTagsGroupedByTechnology = (tags) => {
    const groupedTags = {};

    // Group tags by gen_technology_type
    tags?.forEach(tag => {
      const techType = tag.gen_technology_type;

      // Initialize array for this technology type if it doesn't exist
      if (!groupedTags[techType]) {
        groupedTags[techType] = [];
      }

      // Add the tag to its technology type group
      groupedTags[techType].push(tag);
    });

    return groupedTags;
  };

  const createTagPayload = ({
    tagNumber,
    techName,
    insType,
    prodDesc,
    techId,
    rev,
    divisionCode,
    itemNumber = null,
    itemDescription = null
  }) => {
    const tagPayload = {
      project_id: pkg.project_id,
      package_id: pkg.package_id,
      tag_number: tagNumber,
      created_by: profile.email,
      last_updatedby: profile.email,
      dataset_name: techName === "Vanessa" ? "ISV" : "Rosemount",
      technology_name: techName,
      gen_technology_type: techName,
      gen_instrument_type: insType,
      gen_prod_desc: prodDesc,
      technology_id: techId,
      revision: rev !== "null" ? rev : 1,
      creation_date: getDt(new Date()),
      last_updatedate: getDt(new Date()),
      division_code: divisionCode,
      quantity: 1,
      config_status: `UNCONFIG-${getDtfrmt(new Date())}`,
      tag_line_status: "ACTIVE",
      configuration_import: "NEW",
      selected: "Y",
      tag_enabled: "Y",
    };

    if (itemNumber) {
      tagPayload.gen_part_num = itemNumber;
    }

    if (itemDescription) {
      tagPayload.gen_desc = itemDescription;
    }

    if (techName === "DP Flow") {
      tagPayload.gen_prod_adv = divisionCode;
    }

    if (techName === "Vanessa") {
      tagPayload.gen_costing_status = "NEW";
    }

    if (nonConfigProducts.includes(tagPayload.gen_prod_desc)) {
      tagPayload.config_status = `No Config-${getDtfrmt(new Date())}`;
    }

    return tagPayload;
  };

  const isDuplicateTag = (tagNumber, existingTags) => {
    return existingTags?.some(
      (tag) =>
        tag.tag_number?.toString().toLowerCase().trim() ===
        tagNumber.toString().toLowerCase().trim()
    );
  };

  const returnDataFromSearchItem = (itemData) => {
    console.log("-----returnDataFromSearchItem-----", itemData);
    setIsSearchItemOpen(false);

    if (searchQuantity === "SINGLE") {
      // Handle single item selection - update existing row
      const selectedRow = gridApi?.getSelectedRows()[0];

      const updatedRow = {
        ...selectedRow,
        gen_desc: itemData[0].ITEM_DESCRIPTION,
        division_code: itemData[0].PROD_HIERARCHY_SEGMENT1,
        pur_unit_list_price1: null,
        purchase_total_price: null,
        gen_part_num: itemData[0].ITEM_NUMBER
      };

      dispatch(updTagAct(updatedRow));
    } else {
      const tagPayloads = itemData.map((item, index) => {
        const productName = searchItemType;
        const prefix = getTagPrefix(productName);
        const tagNumber = generateTagNumber(prefix, tags, index);

        const tt = techTyps.find(
          (tt) => tt.product_description === productName
        );

        // const divisionCode = techTypsLkp.find(
        //   (val) =>
        //     val.category === tt.technology_name &&
        //     val.instrumentType === tt.instrument_type &&
        //     val.description === tt.product_description
        // )?.division;

        return createTagPayload({
          tagNumber,
          techName: tt.technology_name,
          insType: tt.instrument_type,
          prodDesc: tt.product_description,
          techId: tt.technology_id,
          rev: tt.revision,
          divisionCode: item.PROD_HIERARCHY_SEGMENT1,
          itemNumber: item.ITEM_NUMBER,
          itemDescription: item.ITEM_DESCRIPTION
        });
      });

      dispatch(showLoader(true));
      dispatch(createTagsAct(getTagsGroupedByTechnology(tagPayloads)));
    }
  };

  const onKeyDown = (e) => {
    // Only proceed if Enter key is pressed and target is tag input
    if (e.keyCode !== 13 || e.target.name !== "tag") {
      return;
    }

    let tagNumber = e.target.value;
    const [tech_name, ins_type, prod_desc, tech_id, rev] = e.target
      .getAttribute("data-package")
      .split("~");

    // Generate tag number if not provided
    if (!tagNumber?.trim()) {
      const prefix = getTagPrefix(prod_desc);
      tagNumber = generateTagNumber(prefix, tags);
    } else {
      tagNumber = tagNumber.toUpperCase();
    }

    // Check for duplicate tags
    if (isDuplicateTag(tagNumber, tags)) {
      setTagState({
        showPkg: true,
        message: `"${tagNumber}" already exists. Please enter a unique value.`,
      });
      return;
    }

    // Get division code
    const divisionCode = techTypsLkp.find(
      (val) =>
        val.category === tech_name &&
        val.instrumentType === ins_type &&
        val.description === prod_desc
    )?.division;

    // Create tag payload
    const tagPayload = createTagPayload({
      tagNumber,
      techName: tech_name,
      insType: ins_type,
      prodDesc: prod_desc,
      techId: tech_id,
      rev,
      divisionCode
    });

    // Reset input and dispatch action
    e.target.value = null;
    dispatch(showLoader(true));

    if (!loading) {
      setTimeout(() => {
        dispatch(createTagsAct(getTagsGroupedByTechnology([tagPayload])));
      }, 500);
    }
  };

  // const returnDataFromSearchItem = (itemData) => {
  //   console.log('-----returnDataFromSearchItem-----', itemData)
  //   // RMT-OSV-INSP-005
  //   setIsSearchItemOpen(false);
  //   if(searchQuantity === 'SINGLE') {
  //     const selectedRow = gridApi?.getSelectedRows()[0];
  //     const updatedRow = {
  //       ...selectedRow,
  //       pur_mod_num_part1: itemData.ITEM_NUMBER,
  //       gen_desc: itemData.ITEM_DESCRIPTION,
  //       gen_part_num: itemData.ITEM_NUMBER,
  //       // gen_detail_desc :  itemData.LONG_DESCRIPTION
  //     };

  //     dispatch(updTagAct(updatedRow));
  //     // gridApi.applyTransaction({ update: [updatedRow] });
  //   }

  // //   [{
  // //     "INVENTORY_ITEM_ID": "26536582",
  // //     "ITEM_NUMBER": "OTHR-W-A0966645-5-21",
  // //     "ITEM_DESCRIPTION": "Customer approval drawing",
  // //     "LONG_DESCRIPTION": "",
  // //     "ICC": "BUY RESALE RMT",
  // //     "PROD_HIERARCHY": "RMT.0.0.0.RMT-GTMCWIKA..YES",
  // //     "PROD_HIERARCHY_SEGMENT1": "RMT",
  // //     "IMO_STATUS": "Phase-In",
  // //     "ITEM_TYPE": "B/R"
  // // },
  // // {
  // //     "INVENTORY_ITEM_ID": "26536584",
  // //     "ITEM_NUMBER": "OTHR-W-A1028123-3-31",
  // //     "ITEM_DESCRIPTION": "Customer approval drawing",
  // //     "LONG_DESCRIPTION": "",
  // //     "ICC": "BUY RESALE RMT",
  // //     "PROD_HIERARCHY": "RMT.0.0.0.RMT-GTMCWIKA..YES",
  // //     "PROD_HIERARCHY_SEGMENT1": "RMT",
  // //     "IMO_STATUS": "Phase-In",
  // //     "ITEM_TYPE": "B/R"
  // // }]
  // }

  const SearchItemComponent = () => {
    return (
      <div
        className='itemFormContainer'
      >
        <Dialog
          maxWidth="xl"
          open={isSearchItemOpen}
          className="muiForm-Modal"
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle
            className="model-title cursor-default close-icon-with-title"
            id="draggable-dialog-title"
          >
            {t("Search Item")}
            <div
              className="cusrsor-normal cusrsor-normal-container"
              onClick={() => {
                setIsSearchItemOpen(false);
              }}
            >
              <MdClose className="cusrsor-normal" />
            </div>
          </DialogTitle>
          <DialogContent className='item-form-dialoag'>
            <ItemForm environment={getEnvironment()} searchQuantity={searchQuantity} returnData={returnDataFromSearchItem} oktaToken={null} />
          </DialogContent>
        </Dialog>
      </div>
    );
  };


  return (
    <>
      {loading && <Loader />}
      {<div
        className={props.cssSidebar}
        style={props.styleSidebar}
      >
        <div className={"sidebar-sticky"}>
          <div className="tree-wrapper"  >
            {
              packages !== undefined &&
              <>
                <div className='my-2 d-flex' style={{ flex: 10, marginLeft: '5px' }}>
                  <div className='w-20 mr-auto pr-1' style={{ flex: 8, position: 'relative' }}>
                    <input onChange={(e) => handleSearchInput(e)} id='tree-search' value={searchtag} type='text' placeholder={t('Search')} maxLength={27} className="tree-search-input"></input>
                    <span className="tree-search-input-suffix" aria-hidden="true" style={{ position: 'absolute' }}>
                      <img src={treeSearch} alt="search" width="auto" height="15"></img>
                    </span>
                  </div>
                  {/* <img src={treeViewCollapse} onClick={() => { handleCloseSideBar(); }} className="d-inline treeButton" alt="tree-collapse" style={{ cursor: "pointer" }}></img> */}
                  <IconButton onClick={() => { handleCloseSideBar() }} size='small' >
                    <FaAnglesLeft />
                  </IconButton>
                </div>
                {
                  !isInstrumentationTab &&
                  <div style={{ padding: '0px 8px 4px 8px', display: 'flex', justifyContent: 'center' }} >
                    <SearchItemBtnGrp onSrchItemClicked={onSrchItemClicked} disabled={isCreateTagDisabled} />
                  </div>
                }
                {
                  isInstrumentationTab &&
                  <div style={{ padding: '0px 8px 4px 8px', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                       <Button
                        variant="contained"    
                        size="small"
                        // type="button"
                        // className="btn btn-sm d-inline-flex align-items-center"
                        onClick={openAddTagDialog}
                        disabled={isCreateTagDisabled}
                        sx={{
                                    width: '91.05px',
                                    height: '28px',
                                    fontSize: "11px",
                                    fontFamily: "NotoSans-Medium",
                                    backgroundColor: primaryColor,
                                    color: "#ffffff",
                                    borderColor: primaryColor,
                                    "&:hover": {
                                      backgroundColor: alpha(primaryColor, 0.9),
                                      borderColor: primaryColor,
                                    },
                                    "&:active": {
                                      backgroundColor: alpha(primaryColor, 0.8),
                                    },
                                  }}
                        
                      >
                        <MdAddCircleOutline style={{ marginRight: '4px' }} />
                        {t('Add Tag')}
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        // type="button"
                        // className="btn btn-sm d-inline-flex align-items-center"
                        onClick={openEditTagDialog}
                         sx={{
                                    width: '88.69px',
                                    height: '28px',
                                    fontSize: "11px",
                                    fontFamily: "NotoSans-Medium",
                                    color: primaryColor,
                                    borderColor: primaryColor,
                                    "&:hover": {
                                      backgroundColor: alpha(primaryColor, 0.04),
                                      borderColor: primaryColor,
                                    },
                                    "&:active": {
                                      backgroundColor: alpha(primaryColor, 0.08),
                                    },
                                  }}
                      >
                        <MdEdit style={{ marginRight: '4px' }} />
                        {t('Edit Tag')}
                      </Button>
                    </div>
                  </div>
                }
                <div className="py-0 mt-0" >
                  {packages}
                  {/*<AiOutlinePlusCircle alt="Add" className="d-inline align-top mr-2 my-1 mx-2 abtn" width="auto" height="35" title="Add Package" />
                                        {/*<input type="text" id='package' name='package' maxLength="60" placeholder="add package..." style={{ height: '20px', width: '70.2%' }} data-project={proj.project_id} onChange={(e) => handleChange(e)} onKeyDown={(e) => onKeyDown(e)} onBlur={(e) => onBlurPkg(e)} />*/}
                </div>

              </>
            }
          </div>
        </div>
        {/* <Modal backdrop="static" centered={true} isOpen={tagState.showPkg} >
          <ModalHeader toggle={togglePkgModal}>Warning</ModalHeader>
          <ModalBody>{tagState.message}</ModalBody>
        </Modal> */}

        <Dialog size='sm' open={tagState.showPkg} className="create-project tags-modal muiForm-Modal" PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title" >
          <DialogTitle className="model-title" id="draggable-dialog-title" toggle={togglePkgModal}>

            <div className="d-flex">
              <div> {t('Warning')} </div>
              <div className="ml-auto close-MUIModal" onClick={() => { setTagState(false) }}>
                <MdClose />
              </div>
            </div>
          </DialogTitle>
          <DialogContent> <div className='pb-3'>  {tagState.message} </div>
          </DialogContent>

        </Dialog>
        <SearchItemComponent />
        <div className='itemFormContainer'>
          <Dialog
            maxWidth="sm"
            open={isAddTagOpen}
            className="muiForm-Modal"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle className="model-title mb-0" id="draggable-dialog-title">
              {t('Add Tag')}
            </DialogTitle>
            <DialogContent>
              <Grid container className="marginRow muiForm mb-2 pt-3" spacing={1.4}>
                <Grid item md={12} xs={12}>
                  <TextField
                    size='small'
                    label={t('Tag Number')}
                    name='tag_number'
                    id='tag_number'
                    type='text'
                    inputProps={{ maxLength: 240 }}
                    onChange={handleAddTagFieldChange('tagNumber')}
                    value={addTagForm.tagNumber}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Autocomplete
                    fullWidth
                    size='small'
                    options={getUnique(addTagTechTypsLkp.filter((item) => item.type !== 'COMMERCIAL').map((item) => item.description)).sort((a, b) => a.localeCompare(b, 'en', { numeric: true, sensitivity: 'base' }))}
                    value={addTagForm.productDescription || null}
                    onChange={(_, value) => handleAddTagFieldChange('productDescription')({ target: { value: value || '' } })}
                    filterOptions={(options, { inputValue }) => {
                      const searchText = inputValue.trim().toLocaleLowerCase();
                      return options.filter((option) =>
                        String(option).toLocaleLowerCase().includes(searchText)
                      );
                    }}
                    renderInput={(params) => <TextField {...params} label={t('Product Description')} required />}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    size='small'
                    label={t('Instrument Type')}
                    name='instrument_type'
                    id='instrument_type'
                    type='text'
                    inputProps={{ maxLength: 240 }}
                    value={addTagForm.instrumentType}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    size='small'
                    label={t('Technology Type')}
                    name='technology_type'
                    id='technology_type'
                    type='text'
                    inputProps={{ maxLength: 240 }}
                    value={addTagForm.technologyType}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className='model-actions'>
              <Button onClick={handleAddTagCancel} className="cnbtn btn btn-outline-success" variant="outlined" style={{ marginRight: '5px', fontSize: '13px' }}>
                {t('Cancel')}
              </Button>
              <Button className="sbtn btn btn-secondary right-space" variant="contained" color="success" onClick={handleAddTagSave} style={{ fontSize: '13px' }}>
                {t('Save')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div className='itemFormContainer'>
          <Dialog
            maxWidth="sm"
            open={isEditTagOpen}
            className="muiForm-Modal"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle className="model-title mb-0" id="draggable-dialog-title">
              {t('Edit Tag')}
            </DialogTitle>
            <DialogContent>
              <Grid container className="marginRow muiForm mb-2 pt-3" spacing={1.4}>
                <Grid item md={12} xs={12}>
                  <TextField
                    size='small'
                    label={t('Tag Number')}
                    name='tag_number_edit'
                    id='tag_number_edit'
                    type='text'
                    inputProps={{ maxLength: 240 }}
                    onChange={handleAddTagFieldChange('tagNumber')}
                    value={addTagForm.tagNumber}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Autocomplete
                    fullWidth
                    size='small'
                    options={getUnique(addTagTechTypsLkp.filter((item) => item.category === addTagForm.technologyType).map((item) => item.description)).sort((a, b) => a.localeCompare(b, 'en', { numeric: true, sensitivity: 'base' }))}
                    value={addTagForm.productDescription || null}
                    onChange={(_, value) => handleAddTagFieldChange('productDescription')({ target: { value: value || '' } })}
                    filterOptions={(options, { inputValue }) => {
                      const searchText = inputValue.trim().toLocaleLowerCase();
                      return options.filter((option) =>
                        String(option).toLocaleLowerCase().includes(searchText)
                      );
                    }}
                    renderInput={(params) => <TextField {...params} label={t('Product Description')} required />}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    size='small'
                    label={t('Instrument Type')}
                    name='instrument_type_edit'
                    id='instrument_type_edit'
                    type='text'
                    inputProps={{ maxLength: 240 }}
                    value={addTagForm.instrumentType}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    size='small'
                    label={t('Technology Type')}
                    name='technology_type_edit'
                    id='technology_type_edit'
                    type='text'
                    inputProps={{ maxLength: 240 }}
                    value={addTagForm.technologyType}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className='model-actions'>
              <Button onClick={handleEditTagCancel} className="cnbtn btn btn-outline-success" variant="outlined" style={{ marginRight: '5px', fontSize: '13px' }}>
                {t('Cancel')}
              </Button>
              <Button className="sbtn btn btn-secondary right-space" variant="contained" color="success" onClick={handleEditTagSave} style={{ fontSize: '13px' }}>
                {t('Save')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>}


    </>
  )
}


export default React.memo(TagTree);